// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__1oLMg","content":"Modal_content__2v8qA","close":"Modal_close__1Bqj0"};